"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var is_node_1 = require("./is-node");
var elog = require("./elog");
var mparticle_tracker_1 = require("./elog/mparticle_tracker");
var csp_category_helper_1 = require("./csp_category_helper");
exports.CLICK = 'click';
exports.VIEW = 'view';
exports.SUBMIT = 'submit';
exports.INTERACTION = 'interaction';
exports.MPARTICLE_EVENT = 'mparticle_event';
exports.CTA = 'cta';
exports.LISTING_TYPE = 'Listing';
exports.CSP_TYPE = 'ComparisonShoppingPage';
exports.ARTICLE_TYPE = 'Article';
exports.SEARCH_TYPE = 'Search';
exports.CATEGORY_TYPE = 'Category';
exports.BRAND_TYPE = 'Brand';
exports.CURATED_SET_TYPE = 'CuratedSet';
exports.MARKDOWN_TYPE = 'Markdown';
exports.MARKETING_TYPE = 'Marketing';
exports.ALBUM_TYPE = 'Album';
var configuredElog = elog;
function setElog(elogInstance) {
    configuredElog = elogInstance;
}
exports.setElog = setElog;
function trackView(data) {
    configuredElog.view(new configuredElog.events.ComponentsView({
        component_name: data.componentName,
        entity_type: data.type,
        entity_ids: data.ids || [],
        context: JSON.stringify(data.context),
    }));
    var mParticleView = data.mParticleView, eventData = tslib_1.__rest(data, ["mParticleView"]);
    if (typeof (mParticleView) === 'function') {
        mparticle_tracker_1.trackEvent(mParticleView(eventData));
    }
    else if (mParticleView) {
        mparticle_tracker_1.trackEvent(mParticleView);
    }
}
exports.trackView = trackView;
function trackInteraction(data) {
    var fullUrl = data.url;
    if (String(fullUrl)[0] === '/') {
        fullUrl = window.location.origin + fullUrl;
    }
    var event = new configuredElog.events.ComponentInteraction({
        component_name: data.componentName,
        interaction_type: data.interactionType || exports.CLICK,
        target_url: fullUrl,
        url: window.location.href,
        referer: document.referrer,
        bumped: data.bumped,
        entity_type: data.type,
        entity_id: String(data.entityId),
        context: JSON.stringify(data.context),
        page: data.page,
        per_page: data.perPage,
        position: data.position,
    });
    configuredElog.interaction(event);
    var mParticleInteraction = data.mParticleInteraction, eventData = tslib_1.__rest(data, ["mParticleInteraction"]);
    if (typeof (mParticleInteraction) === 'function') {
        mparticle_tracker_1.trackEvent(mParticleInteraction(eventData));
    }
    else if (mParticleInteraction) {
        mparticle_tracker_1.trackEvent(mParticleInteraction);
    }
}
exports.trackInteraction = trackInteraction;
function buildListingClickEvent(data, listing, mparticleEventData) {
    return {
        listing: listing,
        eventName: mparticle_tracker_1.MParticleEventName.ClickedListingCard,
        componentName: data.componentName,
        displayStyle: mparticleEventData.displayStyle,
        position: data.position,
    };
}
exports.buildListingClickEvent = buildListingClickEvent;
function trackCSPClick(data, csp, mparticleEventData) {
    return tslib_1.__assign({ cspSlug: csp.slug, cspId: csp.id, componentName: data.componentName, eventName: mparticle_tracker_1.MParticleEventName.ClickedCSPCard, position: data.position, brand: csp.brand && csp.brand.slug, displayStyle: mparticleEventData.displayStyle }, csp_category_helper_1.getCategoryAttributesForMparticle(csp));
}
exports.trackCSPClick = trackCSPClick;
function trackError(_a) {
    var name = _a.name, _b = _a.context, context = _b === void 0 ? {} : _b, error = _a.error, _c = _a.ravenOptions, ravenOptions = _c === void 0 ? {} : _c;
    elog.error(name, context, error, ravenOptions);
}
exports.trackError = trackError;
function trackEvents(data) {
    if (is_node_1.default)
        return;
    switch (data.eventType) {
        case exports.VIEW:
            trackView(data);
            break;
        case exports.INTERACTION:
            trackInteraction(data);
            break;
        default:
            trackInteraction(data);
    }
}
exports.trackEvents = trackEvents;
exports.default = {
    trackEvents: trackEvents,
};
//# sourceMappingURL=tracker.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/tracker.js
// module id = Gmt8
// module chunks = 20 21 22